import { allocationTypeSchema } from './allocation-type.schema';
import { coercedDate } from '../../../utils/coerced-date';
import { z } from 'zod/v4';

export const purchaseOrderSchema = z.object({
  allocationType: allocationTypeSchema,
  purchaseCount: z.number().min(1),
  purchaseOrderNumber: z.string().nullable(),
  purchaseDate: coercedDate,
});

export type PurchaseOrder = z.infer<typeof purchaseOrderSchema>;
